import {gsap, SplitText} from "../Utility/gsap";

export const InitiateHomepageHero = () => {
  const blocks = document.querySelectorAll('.home_hero');

  if(blocks){
    blocks.forEach(block => {
      if(!block.slider){
        block.slider = new TDHomeHeroSlider(block);
      }
    });
  }
}

class TDHomeHeroSlider {
  constructor(el){
    this.el = el;
    this.slides =  this.el.querySelectorAll('.slide');

    // If there's only one slide, return
    if(this.slides.length < 2){
      return;
    }

    this.pause = this.el.getAttribute('data-slide-speed');
    this.fadeSpeed = 600;
    this.contentDelay = this.el.getAttribute('data-content-delay');
    this.activeIndex = 0;
    this.activeSlide = this.getSlide(this.activeIndex);
    this.matchMediaHero = gsap.matchMedia('.home_hero');

    this.el.classList.add('initiated');

    this.splitSlideHeadingIntoWords();

    // Add content animation on initiation.
    this.animateContent();

    this.intervalTimer = setInterval(() => {
      this.changeSlide();
    }, this.pause);
  }

  animateContent(){
    // Add class to animate in slide content
    setTimeout(() => {
      this.activeSlide.classList.add('content-visible');
    }, this.contentDelay);

    // Add class to make animated underline functionality available
    setTimeout(() => {
      this.activeSlide.classList.add('underline-available');
    }, parseInt(this.contentDelay) + 600);

    // Remove classes for slide content visibility and animated line visibility
    setTimeout(() => {
      this.activeSlide.classList.remove('content-visible');
      this.activeSlide.classList.remove('underline-available');
    }, parseInt(this.pause) - (parseInt(this.contentDelay) * 2));
  }

  splitSlideHeadingIntoWords() {
    this.matchMediaHero.add({
      prefersMotion:`(prefers-reduced-motion:no-preference)`
    },(ctx)=>{
      const {prefersMotion} = ctx.conditions;
      if(prefersMotion){
        this.slides.forEach(slide => {
          const headline = slide.querySelector('.home_hero__headline');

          if(!!headline){
            headline.split = new SplitText(
              headline.querySelector('span'), 
              { 
                type:"words",
                wordsClass: "split-text-parent split-text"
              }
            );
            headline.split = new SplitText(
              headline.querySelector('span'), 
              { 
                type:"words",
                wordsClass: "split-text-child split-text"
              }
            );

          }
        });
      }
    });
  }

  changeSlide() {
    this.nextIndex = this.getNextIndex();
    this.nextSlide = this.getSlide(this.nextIndex);
    this.nextSlide.classList.add('fading-in');
    this.activeSlide.classList.add('fading-out');

    setTimeout(() => {
      this.activeSlide.classList.remove('fading-out');
      this.activeSlide.classList.remove('active');
      this.activeSlide.setAttribute('aria-hidden', 'true');
      
      this.nextSlide.classList.add('active');
      this.nextSlide.classList.remove('fading-in');
      this.nextSlide.setAttribute('aria-hidden', 'false');

      this.activeSlide = this.nextSlide;
      this.activeIndex = this.nextIndex;

      this.animateContent();

    }, this.fadeSpeed);
  }
  
  getNextIndex() {
    return this.activeIndex == this.slides.length - 1 ? 0 : this.activeIndex + 1
  }

  getSlide(index) {
    return this.slides[index];
  }
}